"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _ToolTip = _interopRequireDefault(require("../ToolTip/ToolTip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var growInAnimation = {
  '@keyframes growIn': {
    '0%': {
      transform: 'scale(0)'
    },
    '100%': {
      transform: 'scale(1)'
    }
  }
};

var DotMatrixChartDot = function DotMatrixChartDot(_ref) {
  var id = _ref.id,
      label = _ref.label,
      loading = _ref.loading,
      tooltipText = _ref.tooltipText,
      size = _ref.size,
      onClick = _ref.onClick,
      animateIn = _ref.animateIn,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "label", "loading", "tooltipText", "size", "onClick", "animateIn"]);

  var context = (0, _themeUi.useThemeUI)();
  var theme = context.theme;
  var Dot = (0, _themeUi.jsx)(_themeUi.Flex, {
    onClick: onClick && !loading ? function () {
      return onClick(id);
    } : null,
    sx: {
      cursor: onClick && !loading ? 'pointer' : 'default',
      width: '100%',
      height: '100%',
      '&:hover': {
        opacity: onClick && !loading ? '0.8' : '1'
      },
      '&:active': {
        opacity: '1'
      }
    }
  }, (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    sx: _extends({
      bg: 'neutral.1',
      borderRadius: '100%',
      height: size,
      width: size,
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative'
    }, growInAnimation, {
      animationName: animateIn ? 'growIn' : null,
      animationTimingFunction: 'ease-out',
      animationDuration: '400ms',
      animationFillMode: 'backwards'
    })
  }), loading && (0, _themeUi.jsx)(_themeUi.Flex, {
    sx: {
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      top: '50%',
      left: '50%',
      width: function width(theme) {
        return theme.sizes[size] + theme.sizes[1] + "px";
      },
      height: function height(theme) {
        return theme.sizes[size] + theme.sizes[1] + "px";
      }
    }
  }, (0, _themeUi.jsx)(_Spinner["default"], {
    sx: {
      height: '100%',
      width: '100%'
    },
    strokeWidth: theme.borderWidths.thick
  })), label && (0, _themeUi.jsx)(_Text["default"], {
    variant: "display"
  }, label)));

  if (tooltipText) {
    return (0, _themeUi.jsx)(_ToolTip["default"], {
      text: tooltipText
    }, Dot);
  }

  return Dot;
};

DotMatrixChartDot.propTypes = {
  label: _propTypes["default"].string,
  tooltipText: _propTypes["default"].string,
  size: _propTypes["default"].number,
  onClick: _propTypes["default"].func,
  animateIn: _propTypes["default"].bool
};
DotMatrixChartDot.defaultProps = {
  size: 2,
  animateIn: true
};
var _default = DotMatrixChartDot;
exports["default"] = _default;